// src/components/Testimonials.js
import React from "react";

function Testimonials() {
  const testimonials = [
    {
      name: "Aradhye Swarup",
      position: "Thermo Fisher Scientific",
      feedback: "Worked with me on a project - a great collaborator and easy to work with.",
    },
    {
      name: "Jeeth Shah",
      position: "Intern, Labcorp",
      feedback: "A genuinely good person to work with - dependable and professional.",
    },
    {
      name: "Aman L",
      position: "SDE, Couchbase",
      feedback: "I know Parth from our class days - his work quality has always been excellent.",
    },
    {
      name: "Manish Uttreja",
      position: "Chartered Accountant, Standard Chartered Bank",
      feedback: "Parth's work is consistently top-notch and exceeds expectations.",
    },
    {
      name: "Rahul Khatri",
      position: "Founder, AuraX",
      feedback: "Parth's coding skills and logical thinking are very strong.",
    },
    {
      name: "Sushanto Das",
      position: "Intern, UBS",
      feedback: "A very good teammate - reliable, helpful, and fun to work with.",
    },
    {
      name: "Harshit Jain",
      position: "IDFC First Bank",
      feedback: "Parth's professionalism and attitude make him a pleasure to work with.",
    },
    {
      name: "Arjun Singh",
      position: "Manager, Amazon",
      feedback: "Parth is hardworking, positive, and always delivers good results.",
    },
    {
      name: "Siddhanth Varshney",
      position: "Business Analyst, 91wheels",
      feedback: "He's a great guy and a sharp professional to collaborate with.",
    },
    {
      name: "Aprajita Nandkeuliar",
      position: "AI/ML Engineer, Prodapt",
      feedback: "Parth has strong technical depth and is genuinely a good teammate.",
    },
  ];

  return (
    <div className="section-content testimonials-section">
      <h1>Testimonials</h1>
      <p className="section-intro">
        Words from colleagues, mentors, and collaborators who've shared a
        professional journey with me.
      </p>

      <div className="testimonials-grid">
        {testimonials.map((person) => (
          <div className="testimonial-card" key={person.name}>
            <div className="testimonial-text">“{person.feedback}”</div>
            <div className="testimonial-author">
              <h3>{person.name}</h3>
              <p>{person.position}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
